import * as React from 'react';

export const useHistoryState = <TValue>(key: string, value: TValue, setValue: (value: TValue) => void) => {
    React.useEffect(() => {
        const currentState = window.history.state;
        const storedValue = currentState?.[key];

        if (storedValue) {
            setValue(storedValue);
        }
    }, []);

    React.useEffect(() => {
        const currentState = window.history.state || {};
        currentState[key] = value;

        window.history.replaceState(currentState, '');
    }, [value]);
};
